<template>
    <nav role="navigation">
        <div id="menuToggle">
            <input type="checkbox" v-model="abierto" />
            <span></span>
            <span></span>
            <span></span>
            <ul id="menu">
                <li><img class="toggle-icon" src="/img/logo-header.png" alt=""/></li>
                <table class="data">
                    <tr><td style="color: #144AA7;">Aplicación Web SIG</td></tr>
                    <tr><td>Vigilancia</td></tr>
                    <tr><td>Ambiental</td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td style="color: #144AA7;">Elaborado Por:</td></tr>
                    <tr><td>CSIG-DPEF</td></tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr><td style="color: #144AA7;">Consultas</td></tr>
                    <tr><td><img class="toggle-email" src="/img/email.png" alt=""/>csigsoporte@oefa.gob.pe</td></tr>
                </table>
                <!--<li @click="cargarPestana(1)">Buscar Administrado</li>
                <li @click="cargarPestana(2)">Busqueda geografica</li>
                <li @click="cargarPestana(3)">Busqueda por Ambito</li>-->
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "HamburgerMenu",
         props: ['ParamInputClose'],
        data(){
            return {
                abierto: false,
            }
        },
         watch: {
            ParamInputClose(newValue){
                if(newValue){
                    this.abierto = false;
                }
            },
         },    
        methods:{
            cargarPestana(nro){
                this.$emit('tabChange', nro);
                this.abierto = false;
            }
        }
    }
</script>

<style scoped>
    nav {
        padding-left: 15px;
    }
    #menuToggle
    {
        display: block;
        z-index: 1;
        -webkit-user-select: none;
        user-select: none;
    }

    #menuToggle input
    {
        display: block;
        width: 25px;
        height: 32px;
        position: absolute;
        cursor: pointer;

        opacity: 0; /* hide this */
        z-index: 2; /* and place it over the hamburger */

        -webkit-touch-callout: none;
    }

    /*
     * Just a quick hamburger
     */
    #menuToggle span
    {
        display: block;
        width: 25px;
        height: 2px;
        margin-bottom: 5px;
        position: relative;

        background: #144AA7;
        border-radius: 3px;

        z-index: 1;
        transform-origin: 2px 0;

        transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
        background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
        opacity 0.55s ease;
    }

    #menuToggle span:first-child
    {
        transform-origin: 0% 0%;
    }

    #menuToggle span:nth-last-child(2)
    {
        transform-origin: 0% 100%;
    }

    /*
     * Transform all the slices of hamburger
     * into a crossmark.
     */
    #menuToggle input:checked ~ span
    {
        opacity: 1;
        transform: rotate(45deg) translate(-2px, -1px);
        background: #232323;
    }

    /*
     * But let's hide the middle one.
     */
    #menuToggle input:checked ~ span:nth-last-child(3)
    {
        opacity: 0;
        transform: rotate(0deg) scale(0.2, 0.2);
    }

    /*
     * Ohyeah and the last one should go the other direction
     */
    #menuToggle input:checked ~ span:nth-last-child(2)
    {
        transform: rotate(-45deg) translate(0, -1px);
    }

    /*
     * Make this absolute positioned
     * at the top left of the screen
     */
    #menu
    {
        position: absolute;
        width: 300px;
        top: 0;
        left: 0;
        height: 100vh;
        padding: 30px;
        /*padding-top: 125px;*/
        margin: 0;
        background: #d9d9d9;
        list-style-type: none;
        -webkit-font-smoothing: antialiased;
        /* to stop flickering of text in safari */

        transform-origin: 0% 0%;
        transform: translate(-120%, 0);

        transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);

    }

    #menu li
    {
        padding: 10px 0;
        font-size: 1.6em;
        color: #1D85BF;
        cursor: pointer;
    }
    #menuToggle input:checked ~ ul
    {
        transform: none;
    }
    .toggle-icon{
        height: 30px;
        margin-left: 50px;
    }

    .toggle-email{
        height: 25px;
    }
    table {
        border-collapse: collapse;
        border-radius: 1em;
        overflow: hidden;
         width: 90%;
         margin-left: 15px;
    }

    th, td {
        padding: 2px;
        background: white;
        border-bottom: 1px solid white; 
        font-size: medium;
        color: #1d85bf;
        text-align: center;
    }
</style>
